<style>
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/analyze/page" getKey="rows"
        :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button type="default" @click="addShortcut" size="mini" icon="el-icon-plus">
          {{$t('xinzengkuaijiexuanxiang')}}
        </el-button>
      </template>
      <template #canshuleibie="scope">
        {{list(scope.row.nameAlias)}}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="detailShortcut(scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" style="color:red" @click="deleteShortcut(scope.row)">
              {{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
import equipment_model from '@@/pages/web/base/equipment/equipment_model';

export default {
  name: 'web_process_management_analysis_analyze_table',
  components: {
    equipment_model,
  },
  inject: ['shortcut'],
  data() {
    return {
      columns: [{
        label: 'kuaijiexuanxiangmingcheng',
        prop: 'name',
      }, {
        label: 'suoshushebei',
        prop: 'equipment.name',
      }, {
        label: 'canshuleibie',
        type: 'slot',
        // prop: 'nameAlias',
        // type: 'slot',
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }],
      key: 0
    };
  },
  computed: {
    list(){
      return (nameAlias)=>{
        let arr = nameAlias.split(',');
        const translatedArr = [];
        for (let i = 0; i < arr.length; i++) {
         arr[i]= this.$t(arr[i])
          translatedArr.push(arr[i]);
        }
        let translatedStr = translatedArr.join(',');
        return translatedStr
      }
    }

  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = "/web/craft/analyze/listByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.conditions = {
        sn: this.shortcut.sn,
        equipmentId: this.shortcut.equipmentId,
        orderBy: 'createTime desc',
      }
      this.yt.get(1);
    }, 300)
  },
  mounted() {
    console.log('this.$refs',this.$refs.yt)
  },
  methods: {
    // 新增快捷项
    addShortcut() {
      this.shortcut.addShortcut()
    },

    // 编辑快捷项
    detailShortcut(value) {
      this.shortcut.detailShortcut(value)
    },

    // 删除快捷项
    deleteShortcut(value) {
      this.shortcut.deleteShortcut(value)
    }
  }
};
</script>
